import React from "react";
import { brand } from "../mock";

export default function Header() {
  return (
    <header className="relative z-30 w-full pt-7 pb-2">
      <div className="flex items-center justify-center gap-2.5">
        <span className="h-6 w-6 rounded-full bg-gradient-to-br from-violet-300 to-violet-500 shadow-[0_0_18px_rgba(167,139,250,0.6)]" />
        <span className="font-display text-[17px] tracking-tight text-white">
          Duplica <span className="text-white/55 font-medium">tus Ventas</span>
        </span>
      </div>
    </header>
  );
}
